import { useQuery } from 'react-query';

import { getProgressMeasurementMethods as queryFn } from 'api/endPoints/getProgressMeasurementMethods';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProgressMeasurementMethods = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getProgressMeasurementMethods'],
        queryFn: () => queryFn(),
    });
};

export const PROGRESS_MEASUREMENT_METHODS_KEYS = {
    CRITICALITY_WEIGHT: 'CRITICALITY_WEIGHT',
    ACTIVITIES_COMPLETE_WEIGHT: 'ACTIVITIES_COMPLETE_WEIGHT',
    RESOURCE_UNITS: 'RESOURCE_UNITS',
} as const;

export type ProgressMeasurementKey =
    (typeof PROGRESS_MEASUREMENT_METHODS_KEYS)[keyof typeof PROGRESS_MEASUREMENT_METHODS_KEYS];

export interface QueryResponse {
    key: ProgressMeasurementKey;
    value: string;
}
